<div class="popup-wrap2"
     (click)="onVoid($event)">

    <article class="popup-connect-box">

        <div class="connect-head">
            <div class="head-box">
                <div class="hun">{{ hanja }}</div>
            </div>
        </div>

        <div class="connect-body"
             *ngIf="listSaseung3?.length > 0">
            <div class="hun-list">
                <div class="hun-box"
                     *ngFor="let saseung3 of listSaseung3">
                    <div class="hanja">
                        <ng-container *ngFor="let char of getHanjaChars(saseung3.hanja); let i = index">
                            <br *ngIf="i > 0 && i % 2 === 0">
                            <span class="hanja-txt"
                                  [class.first]="i === 0">{{ char }}</span>
                        </ng-container>
                    </div>
                    <div class="saseung-list">
                        <div class="first-line">
                            <span *ngFor="let tone of GetFourTonesArray(saseung3.four_tones)"
                                  class="label-txt">{{ tone }}</span>
                            <span class="first-hun"
                                  [innerHTML]="getFirstHun(saseung3) | resize | keepHtml"></span>
                            <b class="hangul">&nbsp;{{ saseung3.hangul }}</b>
                        </div>
                        <ng-container *ngIf="getRestHun(saseung3) as restHun">
                            <div class="rest-hun"
                                 [innerHTML]="restHun | resize | keepHtml"></div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="connect-body"
             *ngIf="!IsLoading && hasError">
            <div class="error-txt">데이터를 불러오는 데 실패했습니다.</div>
        </div>

        <div class="connect-body"
             *ngIf="!IsLoading && !hasError && !listSaseung3?.length">
            <div class="error-txt">문자 정보가 없습니다.</div>
        </div>

        <div *ngIf="IsLoading"
             class="connect-body">
            <div class="reload-icon">
                <img src="assets/img/loading_icon.gif">
            </div>
        </div>

        <!-- div class="connect-body"
             *ngIf="getMoreTxt()" -->
        <div class="connect-tail">
            <div class="more-link-btn-box">
                <a class="more-link-btn"
                   (click)="onCloseMore($event)">{{ getLeftHanjaCount() > 0 ? '더 보기' : '자세히 보기' }}</a>
                <div *ngIf="getLeftHanjaCount() > 0"
                     class="more-txt">{{ getMoreTxt() }}
                </div>
            </div>

            <div class="menu-box">
                <a class="close-btn"
                   (click)="onClose($event)"></a>
            </div>

        </div>

    </article>
</div>
